import {
  AlignmentHorizontal,
  AlignmentVertical,
  Teaser,
} from "@redotech/redo-model/signup-form";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";

// full-screen-size display flex
export const FixedContainer = memo(function TeaserContainer({
  teaser,
  children,
}: {
  teaser: Teaser;
  children: React.ReactNode;
}) {
  return (
    <Flex
      align={toFlexAlign(teaser.positionVertical)}
      justify={toFlexJustify(teaser.positionHorizontal)}
      p="md"
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        pointerEvents: "none",
        zIndex: 1000000,
      }}
    >
      {children}
    </Flex>
  );
});

function toFlexAlign(alignment: AlignmentVertical) {
  switch (alignment) {
    case "top":
      return "flex-start";
    case "center":
      return "center";
    case "bottom":
      return "flex-end";
  }
}

function toFlexJustify(alignment: AlignmentHorizontal) {
  switch (alignment) {
    case "left":
      return "flex-start";
    case "center":
      return "center";
    case "right":
      return "flex-end";
  }
}
